module.exports = __webpack_public_path__ + "img/avatar-s-1.8edbcded.png";